// extracted by mini-css-extract-plugin
export default {"rootDiv":"style_rootDiv__7gb8e","content":"style_content__i3viK","header":"style_header__6ubp4","lastreons":"style_lastreons__mruO6","offers":"style_offers__jYW+X"};